export { default as CurrentRanking } from './CurrentRanking'
export { default as RankingIQ } from './RankingIQ'
export { default as PushQuizz } from './PushQuizz'
export { default as PushHighScore } from './PushHighScore'
export { default as BestRanking } from './BestRanking'
export { default as QuizzRanking } from './QuizzRanking'
export { default as ChartRanking } from './ChartRanking'



// WEBPACK FOOTER //
// ./src/components/Challenge/index.js